import { H2 } from 'foundations-components/transitional/components/H2';
import styled from 'foundations-theming/utils';
import { getSectionBackgroundStyle } from 'academy-common-lib/utils/Styling';
import PublicCurriculumCard from './PublicCurriculumCard';
import { List } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Schema from '../../publicSeo/components/Schema';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullWidthBackgroundWrapper = styled.section.withConfig({
  displayName: "PublicPageCurriculumSection__FullWidthBackgroundWrapper",
  componentId: "sc-1ayahlp-0"
})(["", ""], ({
  $useMarketingTheme,
  theme
}) => getSectionBackgroundStyle($useMarketingTheme ? theme.color['fill-accent-green-subtle-alt'] : theme.color['fill-accent-neutral-subtle']));
const PublicPageCurriculumSection = ({
  items
}) => {
  const isMarketingThemeEnabled = getMarketingThemePreference();
  if (items.length === 0) return null;
  const itemsWithLandingPage = items.filter(item => item.landingPageUrl);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(FullWidthBackgroundWrapper, {
      $useMarketingTheme: isMarketingThemeEnabled,
      children: /*#__PURE__*/_jsx(View, {
        as: "section",
        "data-test-id": "public-page-curriculum-section",
        minBlockSize: "400px",
        paddingBlock: "1100",
        children: /*#__PURE__*/_jsxs(Text, {
          color: isMarketingThemeEnabled ? 'text-core-on-fill-default' : 'text-inverse-default',
          children: [itemsWithLandingPage.length > 0 && /*#__PURE__*/_jsx(Schema, {
            object: {
              ['@type']: 'ItemList',
              itemListElement: itemsWithLandingPage.map((item, index) => ({
                ['@type']: 'ListItem',
                position: index + 1,
                url: item.landingPageUrl
              }))
            }
          }), /*#__PURE__*/_jsx(H2, {
            color: isMarketingThemeEnabled ? 'text-core-on-fill-default' : 'text-inverse-default',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.curriculum.curriculum"
            })
          }), /*#__PURE__*/_jsx(List, {
            childStyles: {
              marginBlockEnd: '600'
            },
            lastChildStyles: {
              marginBlockEnd: '0'
            },
            wrapChildren: true,
            children: items.map(item => {
              var _item$href;
              return /*#__PURE__*/_jsx(PublicCurriculumCard, {
                contentTypeName: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.contentCard.lessonType"
                }),
                description: item.description,
                duration: item.duration,
                href: (_item$href = item.href) !== null && _item$href !== void 0 ? _item$href : '',
                id: item.id,
                instructorName: item.instructorName,
                landingPagePath: item.landingPagePath,
                thumbnailUrl: item.thumbnailUrl,
                title: item.name
              }, item.id);
            })
          })]
        })
      })
    })
  );
};
export default PublicPageCurriculumSection;